import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import React, { useRef, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import Grid from '@mui/material/Grid';
import useWebContext from '../../hooks/useWebContext';
import useMyMApi from "../../hooks/useMyMApi";
import { MyMCloseButton } from '../../ui-elements/MyMButton';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import NotifyMessagePage from '../../ui-parts/NotifyMessagePage';
import { MyMLink } from '../../ui-elements/MyMLink';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
/**
 * Help Page Component
 */
const Help = ({ handleClosePage }) => {
  const screenId = 'MyM908';
  const { controlSettings, screenSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  // 2025.7.7 MyMine Version3.0対応 Add Start
  const [viewRecaptcha, setViewRicaptcha] = useState(false);
  const recaptchaRef = useRef(null);
  // 2025.7.7 MyMine Version3.0対応 Add End
  // 2025.7.7 MyMine Version3.0対応 Add Start
  const headerQuestionList =
    [
      {
        questionLabel: controlSettings.LabelList.lblQuestionHeader1,
        questionLink: controlSettings.LabelList.lnkQuestionHeader1,
      },
      {
        questionLabel: controlSettings.LabelList.lblQuestionHeader2,
        questionLink: controlSettings.LabelList.lnkQuestionHeader2,
      },
      {
        questionLabel: controlSettings.LabelList.lblQuestionHeader3,
        questionLink: controlSettings.LabelList.lnkQuestionHeader3,
      }
    ];
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  // 2025.7.7 MyMine Version3.0対応 Add End
  // 2025.7.7 MyMine Version3.0対応 Add Start
  const handleClickEmail = () => {
    if (screenSettings.ReCaptchaOnFlg === 1) {
      setViewRicaptcha(true); // reCAPTCHA表示へ切替
    } else {
      window.location.href = `mailto:${screenSettings.ContactMailAddress}`; // 直接メール起動
    }
  };

  const onCaptchaChange = (token) => {
    const callbackSuccess = (result) => {
      if (result) {
        window.location.href = `mailto:${screenSettings.ContactMailAddress}`; // 認証成功後にメール起動
        setViewRicaptcha(false); // reCAPTCHA非表示
      }
    };
    const callbackFailed = () => {
      setViewRicaptcha(false);
    };
    apiRequest.requestJson('api/help/captcha', 'POST', callbackSuccess, callbackFailed, { token });
  };

  // 2025.7.7 MyMine Version3.0対応 Add End

  const isMobile = useMediaQuery('(max-width:499px)');
  const isMid = useMediaQuery('(min-width:500px) and (max-width:800px)');

  return (
    // 2025.7.7 MyMine Version3.0対応 Add Start
    <NotifyMessagePage isModalPage={true}>
      <Box
        sx={{
          width: isMobile ? '90%' : isMid ? '480px' : '700px',
          maxWidth: isMobile ? '90vw' : isMid ? '700px' : '1000px',
          margin: '0 auto',
          padding: isMobile ? '10px 2px' : isMid ? '20px 5px' : '30px 10px',

        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClosePage}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ padding: isMobile ? '12px 2px' : isMid ? '20px 5px' : '30px 10px', overflowY: 'auto' }}>

          <Box>
            <Grid>
              <MyMVariantLabel variant='h5' className='fw-bold mb-3' sx={{ textAlign: 'center' }} >
                {controlSettings.LabelList.lblHelpTitle}
              </MyMVariantLabel>
            </Grid>
            <Grid sx={{ padding: '0px 10px 30px' }}>
              <Grid sx={{ paddingBottom: 1 }}>
                <MyMVariantLabel>
                  {controlSettings.LabelList.lblHeaderLabel}
                </MyMVariantLabel>
              </Grid>
              {headerQuestionList.map((questionHeader, i) =>
                <Grid
                  container
                  key={`header-question-${i}`}
                  spacing={1}
                  sx={{ paddingBottom: 1 }}
                  alignItems="flex-start"
                >
                  {/* ラベル部分 */}
                  <Grid item>
                    <MyMVariantLabel
                    >
                      {questionHeader.questionLabel}
                    </MyMVariantLabel>
                  </Grid>

                  {/* リンク部分 */}
                  <Grid item xs>
                    <MyMLink
                      onClick={() => scrollToSection(`section-${i + 1}`)}
                      sx={{ lineHeight: 1.4, textAlign: "left", wordBreak: "break-word" }}
                    >
                      <MyMVariantLabel
                      >
                        {questionHeader.questionLink}
                      </MyMVariantLabel>
                    </MyMLink>
                  </Grid>
                </Grid>
              )}

            </Grid>
          </Box>
          <Box sx={{ width: '100%', borderBottom: '1px solid black', marginBottom: 2 }} id="section-1" />
          {/*Question1*/}
          <Box >
            <Box sx={{ padding: '0px 13px 0px' }}>
              <Grid sx={{ paddingBottom: '20px' }}>
                <MyMVariantLabel fontWeight='bold'>{controlSettings.LabelList.lblQuestion1}</MyMVariantLabel>
              </Grid>
              <Grid sx={{ paddingBottom: '10px' }}>
                <MyMLabel>{controlSettings.LabelList.lblAnswer1}</MyMLabel>
              </Grid>
            </Box>
            {/*Step1*/}
            <Box
              sx={{
                backgroundColor: '#E8E8E8',
                height: '45px',
                width: '100%',
                paddingLeft: '13px'
              }}
              className='d-flex align-items-center'
            >
              <Grid >
                <MyMVariantLabel>{controlSettings.LabelList.lblStep1}</MyMVariantLabel>
              </Grid>
            </Box>
            <Box sx={{ padding: '15px 13px 0' }}>
              <Grid sx={{ paddingBottom: '20px' }}>
                <MyMLabel>{controlSettings.LabelList.lblAnswer1_1}</MyMLabel>
              </Grid>
              <Grid sx={{ paddingBottom: '20px' }} className="d-flex align-items-center justify-content-center">
                <Link href={process.env.REACT_APP_HCMID_TOP_URL} target="_blank">{controlSettings.LabelList.lnkAnswer}</Link>
              </Grid>
              <Grid sx={{ paddingBottom: '20px' }}>
                <MyMLabel sx={{ opacity: '0.5' }}>{controlSettings.LabelList.lblAnswer1_2}</MyMLabel>
              </Grid>
            </Box>
          </Box>
          {/*Step2*/}
          <Box
            sx={{
              backgroundColor: '#e8e8e8',
              height: '45px',
              width: '100%',
              paddingLeft: '13px'
            }}
            className='d-flex align-items-center'
          >
            <Grid >
              <MyMVariantLabel>{controlSettings.LabelList.lblStep2}</MyMVariantLabel>
            </Grid>
          </Box>
          <Box sx={{ padding: '15px 13px 0' }}>
            <Grid sx={{ paddingBottom: '20px' }}>
              <MyMLabel>{controlSettings.LabelList.lblAnswer2_1}</MyMLabel>
            </Grid>
            <Grid sx={{ paddingBottom: '20px' }} className="d-flex align-items-center justify-content-center">
              <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgAnswer1_2} style={{ maxWidth: isMobile ? 200 : 320 }} />
            </Grid>
          </Box>
          {/*Step3*/}
          <Box
            sx={{
              backgroundColor: '#e8e8e8',
              height: '45px',
              width: '100%',
              paddingLeft: '13px'
            }}
            className='d-flex align-items-center'
          >
            <Grid >
              <MyMVariantLabel>{controlSettings.LabelList.lblStep3}</MyMVariantLabel>
            </Grid>
          </Box>
          <Box sx={{ padding: '15px 13px 0' }}>
            <Grid sx={{ paddingBottom: '20px' }}>
              <MyMLabel>{controlSettings.LabelList.lblAnswer3_1}</MyMLabel>
            </Grid>
            <Grid sx={{ paddingBottom: '20px' }} className="d-flex align-items-center justify-content-center">
              <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgAnswer1_3} style={{ maxWidth: isMobile ? 200 : isMid ? 485 : 600 }} />
            </Grid>
          </Box>
          {/*Step4*/}
          <Box
            sx={{
              backgroundColor: '#e8e8e8',
              height: '45px',
              width: '100%',
              paddingLeft: '13px'
            }}
            className='d-flex align-items-center'
          >
            <Grid >
              <MyMVariantLabel>{controlSettings.LabelList.lblStep4}</MyMVariantLabel>
            </Grid>
          </Box>
          <Box sx={{ padding: '15px 13px 0' }}>
            <Grid sx={{ paddingBottom: '20px' }}>
              <MyMLabel>{controlSettings.LabelList.lblAnswer4_1}</MyMLabel>
            </Grid>
            <Grid sx={{ paddingBottom: '20px' }}>
              <MyMLabel sx={{ opacity: '0.5' }}>{controlSettings.LabelList.lblAnswer4_2}</MyMLabel>
            </Grid>
          </Box>
          <Box sx={{ width: '100%', borderBottom: '1px solid black', marginBottom: 2 }} id="section-2" />
          {/*Question2*/}
          <Box id='section-2'>
            <Box sx={{ padding: '0px 13px 0px' }}>
              <Grid sx={{ paddingBottom: '20px' }}>
                <MyMVariantLabel fontWeight='bold'>{controlSettings.LabelList.lblQuestion2}</MyMVariantLabel>
              </Grid>
              <Grid sx={{ paddingBottom: '10px' }}>
                <MyMLabel>{controlSettings.LabelList.lblAnswer2}</MyMLabel>
              </Grid>
              <Grid sx={{ paddingBottom: '20px' }} className="d-flex align-items-center justify-content-center">
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgAnswer2_1} style={{ maxWidth: isMobile ? 200 : isMid ? 485 : 600 }} />
              </Grid>
            </Box>
          </Box>
          <Box sx={{ width: '100%', borderBottom: '1px solid black', marginBottom: 2 }} id="section-3" />
          {/*Question3*/}
          <Box sx={{ padding: '0px 13px 30px' }} >
            <Grid sx={{ paddingBottom: '20px' }}>
              <MyMVariantLabel fontWeight='bold'>{controlSettings.LabelList.lblQuestion3}</MyMVariantLabel>
            </Grid>
            <Grid sx={{ paddingBottom: '10px' }}>
              <MyMLabel>{controlSettings.LabelList.lblAnswer3}</MyMLabel>
            </Grid>
            <Grid >
              <Grid item sx={{ paddingBottom: '20px' }}>
                <MyMLabel>
                  {controlSettings.LabelList.lblHcmIdSupport1_1}
                  <MyMLink
                    onClick={() => window.open(screenSettings.ContactUrl, '_blank')}
                    href={screenSettings.ContactUrl}
                    sx={{ paddingLeft: '5px' }}
                  >
                    {controlSettings.LabelList.lnkHcmIdSupport}
                  </MyMLink>
                </MyMLabel>
                <MyMLabel>
                  {controlSettings.LabelList.lblHcmIdSupport1_2}
                </MyMLabel>
              </Grid>
              <Grid item sx={{ paddingBottom: '20px' }}>
                <MyMLabel>
                  {controlSettings.LabelList.lblAnswerEmail}
                  <MyMLink sx={{ paddingLeft: '5px' }} onClick={() => handleClickEmail()}>
                    {controlSettings.LabelList.lnkMyMSupport}
                  </MyMLink>
                </MyMLabel>
                {screenSettings.ReCaptchaOnFlg === 1 && (
                  <MyMLabel sx={{ paddingLeft: isMobile ? '6px' : '11px' }}>
                    {controlSettings.LabelList.lblCapcha}
                  </MyMLabel>
                )}

                {screenSettings.ReCaptchaOnFlg === 1 && viewRecaptcha && (
                  <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={screenSettings.SiteKey}
                      onChange={onCaptchaChange}
                      size={isMobile ? "compact" : "normal"}
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
          <Box className='d-flex align-items-center justify-content-center'>
            <MyMCloseButton handleClose={handleClosePage} closeText={controlSettings.LabelList.btnClose} />
          </Box>
        </Box>
      </Box>
    </NotifyMessagePage>
  );
  // 2025.7.7 MyMine Version3.0対応 Add End
}

export default Help;
